import { render, staticRenderFns } from "./OrgDashboard.vue?vue&type=template&id=c49f2eae"
import script from "./OrgDashboard.vue?vue&type=script&lang=js"
export * from "./OrgDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports